import apiConstants from "../constants/apiConstants";
import { axios } from "../utils/axios";

const base = `${process.env.REACT_APP_API_HOST}/${apiConstants.CATALOGUE}`;
const data = async (p) => (await p).data;

// Staff: the Zoho vendor-side catalogue, read live and written through.
export const catalogueMeta = () => data(axios.get(`${base}/meta`));
export const searchProducts = (q) => data(axios.get(`${base}/products`, { params: { q } }));
export const getProduct = (id) => data(axios.get(`${base}/products/${id}`));
export const createProduct = (body) => axios.post(`${base}/products`, body);
export const updateProduct = (id, body) => axios.put(`${base}/products/${id}`, body);
export const createVariant = (productId, body) => axios.post(`${base}/products/${productId}/variants`, body);
export const updateVariant = (id, body) => axios.put(`${base}/variants/${id}`, body);
export const addRate = (variantId, body) => axios.post(`${base}/variants/${variantId}/rates`, body);
export const setRateStatus = (rateId, status) => axios.put(`${base}/rates/${rateId}/status`, { status });
export const listVendors = () => data(axios.get(`${base}/vendors`));
export const getVendor = (id) => data(axios.get(`${base}/vendors/${id}`));
export const createVendor = (body) => axios.post(`${base}/vendors`, body);
export const updateVendor = (id, body) => axios.put(`${base}/vendors/${id}`, body);

// Product images: the vendor's original photo and the cleaned catalogue
// version. Upload is multipart; the server stores it and signs a URL back.
export const listProductImages = (productId) => data(axios.get(`${base}/products/${productId}/images`));
export const uploadProductImage = (productId, form) => axios.post(`${base}/products/${productId}/images`, form);
export const setPrimaryImage = (id) => axios.put(`${base}/images/${id}/primary`, {});
export const deleteProductImage = (id) => axios.delete(`${base}/images/${id}`);

// The customer-facing listing: what a society sees, and what it pays.
export const listListings = () => data(axios.get(`${base}/listings`));
export const getListing = (productId) => data(axios.get(`${base}/products/${productId}/listing`));
export const saveListing = (productId, body) => axios.put(`${base}/products/${productId}/listing`, body);
export const setListingStatus = (productId, status) => axios.put(`${base}/products/${productId}/listing/status`, { status });
export const setPrice = (productId, body) => axios.post(`${base}/products/${productId}/prices`, body);
export const removePrice = (id) => axios.delete(`${base}/prices/${id}`);
export const getPriceList = () => data(axios.get(`${base}/price-list`));

// Pricing policy per category: a rule, a preview of what it would do, and
// the run that writes it.
export const listPolicies = () => data(axios.get(`${base}/pricing-policies`));
export const savePolicy = (body) => axios.put(`${base}/pricing-policies`, body);
export const runPolicy = (body) => axios.post(`${base}/pricing-policies/run`, body);

// How old the prices we buy at are, and asking a vendor to refresh them.
export const rateFreshness = (params = {}) => data(axios.get(`${base}/rate-freshness`, { params }));
export const askVendorForRates = (vendorId, body = {}) => axios.post(`${base}/rate-freshness/ask/${vendorId}`, body);
